import PopupLayer from './PopupLayer';

export default PopupLayer;